export const Home ="/"
export const category ="/categories/:slug"
export const products_subcategory ="/products-subcategory/:slug/:slug1"
export const brands ="/brands/:slug/:slug2"
export const brands1 ="/brands/:slug"
export const products_category ="/products-category/:slug"
export const ordesuccess ="/order/thanks/:slug"
export const myaccount ="/myaccount"
export const Paymentfail ="/order/payment-failure"
export const Resetpassword ="/reset-password"
export const myaccount_profile ="/myaccount/profile"
export const address ="/address"
export const Tabbyplan ="/tabbyplan"
export const changepassword ="/change-password"
export const trackyourorder ="/track-your-order"
export const trackyourorderid ="/track-your-orderbyid"
export const trackyourorderreference ="/track-your-orderbyrefrrenceid"
export const cart ="/cart"
export const complaints ="/complaints"
export const mywishlist ="/my-wishlist"
export const Placecomplaints ="/place-a-complaints"
export const Complaintsuccss ="/success-complaints"
export const manageComplaint ="/manage-complaint"
export const product_details ="/details/:slug/:slug"
export const delivertaddress ="/deliveryaddress"
export const Payment ="/Payment"
export const perfumes ="/perfumes"
export const bundle_deals ="/bundle-deals"
export const timefest ="/time-fest"
export const tv_super_Sale ="/TV-Super-Sale"
export const bhd_price ="/BHD-0-to-2"
export const omr_price ="/OMR-0-to-2"
export const khd_price ="/KD-0-to-2"
export const qar_price ="/QAR-1-to-20"
export const aed_price ="/AED-1-to-20"
export const bundledeals ="/bundle-deals"
export const mobilefest ="/mobile-fest"
export const saverzone ="/saver-zone"
export const deals_of_the_day ="/deals-of-the-day"
export const clearance_sale ="/clearance"
export const top_selling ="/deals/Top-Selling-Products"
export const search_result ="/search-result/:slug"
export const myorders ="/my-orders"
export const privacypolicy ="/privacy-policy"
export const termsandconditions ="/terms-and-conditions"
export const faqs ="/faqs"
export const Affiliateprogram ="/affiliate-program"
export const blogs ="/blogs"
export const sitemap ="/sitemap"
export const Warienty ="/return-policy"
export const Contactus ="/contactus"
export const Aboutus ="/aboutus"
export const Sellwithus ="/sell-with-us"
export const blogscat ="/blogs/:slug/:slug1"
export const blogDetail ="/blog/:slug/:slug1"
export const feed1 ="/feed/:slug"
export const feed2 ="/feed/:slug/:slug1"
export const summer_sale ="/summer-sale"
// export const TailwindView ="/tailwind-view"